<section class="workspace-wrapper">
  <form [formGroup]="searchForm">
    <div class="workspace-header">
      <h1>Workspaces</h1>
      <input formControlName="field" type="text" class="search-field" placeholder="Search workspaces..." />
      <a routerLink="create" mat-flat-button extended class="new-workspace-button">
        <mat-icon>add</mat-icon>
        Create New Workspace</a
      >
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Workspace options">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <a mat-menu-item routerLink="template">
          <mat-icon>dashboard</mat-icon>
          <span>Template control</span>
        </a>
      </mat-menu>
    </div>
    <div class="workspace-filter-container">
      <mat-slide-toggle class="mine-toggle" formControlName="onlyMine"> My Workspaces </mat-slide-toggle>

      <mat-form-field class="sort-select" >
        <mat-label>Sort</mat-label>
        <mat-select formControlName="select">
          <mat-option [value]="null">None</mat-option>
          @for (sortValue of sortValues; track sortValue.id) {
            <mat-option [value]="sortValue.id">{{ sortValue.text }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (workspaceIsLoading$ | async) {
        <mat-progress-spinner mode="indeterminate" [diameter]="40" color="primary"></mat-progress-spinner>
      }
      <button mat-icon-button class="view-change" type="button" (click)="isListView = !isListView">
        @if (isListView) {
          <mat-icon>view_module</mat-icon>
        } @else {
          <mat-icon>list</mat-icon>
        }
      </button>
    </div>
  </form>
  <div class="workspace-list" [class.column]="isListView">
    @if (isListView) {
      @for (sortedElement of pagedWorkspaces$ | async; track sortedElement.id) {
        <app-workspace-list-element
          [disabled]="!sortedElement.isMember"
          [element]="sortedElement"></app-workspace-list-element>
      }
    } @else {
      @for (sortedElement of pagedWorkspaces$ | async; track sortedElement.id) {
        <app-workspace-card [disabled]="!sortedElement.isMember" [element]="sortedElement"></app-workspace-card>
      }
    }
    @if (!(pagedWorkspaces$ | async)?.length) {
      <h2 class="workspace-empty-list">Empty list</h2>
    }
  </div>

  @if (totalWorkspacesLength$ | async) {
    <mat-paginator
      (page)="handlePageEvent($event)"
      [length]="totalWorkspacesLength$ | async"
      [pageSize]="paginatorTrigger$.value.pageSize"
      [pageIndex]="paginatorTrigger$.value.pageIndex"
      [pageSizeOptions]="pageSizeOptions">
    </mat-paginator>
  }
</section>
